export default "__VITE_ASSET__gu_a7uPt__";